import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import { useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useSidebarContext } from "../../../../../context/SidebarContext";
// import {
//   convertCount2ToSeconds,
//   convertTimeTakenToSeconds,
// } from "../../../../Utils/MeetingFunctions";
import StepChart from "../../CreateNewMeeting/StepChart";
import { useRecording } from "../../../../../context/RecordingContext";
import ConfirmationModal from "../../../../Utils/ConfirmationModal";
import { API_BASE_URL } from "../../../../Apicongfig";
import { convertCount2ToSeconds, convertTimeTakenToSeconds, formatPauseTime } from "../../../../Utils/MeetingFunctions";

const InviteStepChart = ({ meetingId,steps, meeting,refreshMeeting }) => {
  const location = window.location.href;
  const navigate = useNavigate();
  const fromReport = location.includes("step-details")
    ? true
    : location.includes("meetingDetail")
    ? true
    : false;
  const [t] = useTranslation("global");
  const { toggle } = useSidebarContext();
  const { startRecording } = useRecording();
  const [selectedBar, setSelectedBar] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [stepId, setStepId] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isDrop, setIsDrop] = useState(false);

  useEffect(() => {
    if (isModalOpen) {
      toggle(false);
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (fromReport) {
      setIsModalOpen(true);
    }
  }, [fromReport]);

  useEffect(() => {
    if (meeting || steps) {
      // const { steps } = meeting;
      let accumulatedCount2 = steps?.length > 0 ? steps[0]?.count2 : 0;
      let storedTime = moment(meeting?.start_time, "HH:mm"); // Initialize stored time
      const formattedData = steps
        ?.map((step, index) => {
          let count1 = 0;
          let count2 = step.count2;

          if (index > 0) {
            accumulatedCount2 += step.count2;
            count1 = accumulatedCount2 - count2;
          }

          // Calculate new stored time if selectedIndex > 0
          if (index === selectedIndex) {
            storedTime.add(count1, "minutes");
          }

          return {
            x: step.title,
            y: [count1, count1 + count2, count2],
            // unit: step.time_unit,
          };
        })
        .reverse();
      setChartData(formattedData);
    }
  }, [meeting,steps, selectedIndex]);

  const colors = steps?.map((step) => {
      if (
        step?.step_status === "in_progress" &&
        convertTimeTakenToSeconds(step?.time_taken) >
          convertCount2ToSeconds(step?.count2, step?.time_unit)
      ) {
        return "#FF4560"; // Red
      } else if (step?.step_status === "completed") {
        return "#00E396"; // Green
      } else if (step?.step_status === null) {
        return "#008FFB"; // Blue
      } else if (step?.step_status === "to_finish") {
        return "#ff9800"; // Blue
      } else if (step?.step_status === "todo") {
        return "#6c757d"; // Blue
      } else {
        return "#f2db43"; // Green
      }
    })
    .reverse();

  const localizeTimeTakenActive = (timeTaken) => {
    if (!timeTaken) return "";

    // Retrieve localized time units
    const timeUnits = t("time_unit", { returnObjects: true });

    // Split the timeTaken string by " - " to separate time components
    const timeParts = timeTaken.split(" - ");

    // Initialize variables for each time component
    let days = null;
    let hours = null;
    let minutes = null;
    let seconds = null;

    // Iterate over each part and assign it to the corresponding variable
    timeParts.forEach((part) => {
      if (part.includes("day")) {
        days = part;
      } else if (part.includes("hour")) {
        hours = part;
      } else if (part.includes("min")) {
        minutes = part;
      } else if (part.includes("sec")) {
        seconds = part;
      }
    });

    // Check if days are present
    const hasDays = Boolean(days);

    // Determine what to show based on the presence of days
    let result = "";
    if (hasDays) {
      // Show days and hours if days are present
      result = [days, hours].filter(Boolean).join(" - ");
    } else if (hours) {
      // Show only hours and minutes if hours and minutes are present
      result = [hours, minutes].filter(Boolean).join(" - ");
    } else if (minutes) {
      // Show minutes only if no days or hours are present
      // result = minutes;
      result = [minutes, seconds].filter(Boolean).join(" - ");
    } else {
      result = seconds;
    }

    // Return empty string if result is undefined or empty
    if (!result) return "";

    // Localize and return the result
    return result
      .split(" ")
      .map((part) => (isNaN(part) ? timeUnits[part] || part : part))
      .join(" ");
  };
  const RemoveTime = (time_taken, time_unit) => {
    if (!time_taken) return;
    if (time_unit === "days") {
      // Split the time_taken string by ' - ' and only keep the first two parts (days and hours)
      const parts = time_taken?.split(" - ");
      if (parts?.length > 2) {
        return parts.slice(0, 2).join(" - ");
      }
    }
    return time_taken;
  };

  const options = {
    xaxis: {
      type: "category",
      labels: {
        show: false,
        formatter: function (val, index, opts) {
          const step = steps[index];
          const timeTaken = step?.time_taken || "";
          const firstValue = timeTaken.split(" - ")[0]; // Get the first value before the dash

          return firstValue;
        },
      },
    },
    yaxis: {
      show: true,
      labels: {
        formatter: function (val, index) {
          return val;
        },
      },
    },
    chart: {
      height: 650,
      zoom: false,
      type: "rangeBar",
      events: {
        click: function (event, chartContext, config) {
          const { dataPointIndex } = config;
          setChartData((prevChartData) => {
            if (
              dataPointIndex !== undefined &&
              dataPointIndex >= 0 &&
              dataPointIndex < prevChartData?.length
            ) {
              const updatedSelectedIndex =
                prevChartData.length - 1 - dataPointIndex;
              setSelectedIndex(updatedSelectedIndex);
              const clickedChartData = prevChartData[dataPointIndex];
              if (
                clickedChartData &&
                clickedChartData.y &&
                clickedChartData.y.length === 3
              ) {
                setSelectedBar(clickedChartData.x);

                const selectedStep = steps[updatedSelectedIndex];
                if (selectedStep?.step_status === "completed" || selectedStep?.step_status === null || selectedStep?.step_status === "to_finish" || selectedStep?.status === "todo" || selectedStep?.status === "cancelled" || selectedStep?.status === "abort") {
                  // setDoneMomentsModal(true);
                  navigate(`/step/${selectedStep?.id}`, {
                    state: { meeting: meeting },
                  });
                } else if (selectedStep?.step_status === "in_progress") {
                  // setIsModalOpen(true);
                  changeStatusAndPlay(meeting);
                } else {
                  // setIsUpdated(true);
                  setIsModalOpen(true);
                  setStepId(selectedStep?.id);
                  setIsDrop(false)
                  // setStepIndex(selectedIndex)
                }
              }
            }

            return prevChartData;
          });
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        borderRadius: 15,
        barHeight: 35,
      },
    },
    tooltip: {
      enabled: true,
      shared: false,
      intersect: true,
      x: {
        show: true,
        formatter: function (val, opts) {
          return val; // Or any specific logic for x-axis tooltip
        },
      },
      y: {
        formatter: function (val, opts) {
          let step;
          let sanitizedTimeTaken = 0; // Default message

          if (steps && opts && opts.dataPointIndex !== undefined) {
            const reversedIndex =
              steps?.length - 1 - opts.dataPointIndex;
            step = steps[reversedIndex];

            if (
              step &&
              step.time_taken &&
              step?.step_status === "in_progress"
            ) {
              sanitizedTimeTaken = step.time_taken;
            }
          }
          return sanitizedTimeTaken && sanitizedTimeTaken;
        },
      },
    },
    grid: {
      row: {
        colors: ["#fff", "#fff"],
        opacity: 1,
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ["black"],
        fontSize: "8px",
      },
      formatter: function (val, opts) {
        const reversedIndex = steps?.length - 1 - opts.dataPointIndex;
        const step = steps[reversedIndex];

        const sanitizedTimeTaken = localizeTimeTakenActive(
          step?.time_taken?.replace("-", "")
        );

        if (
          step?.step_status === "in_progress" ||
          step?.step_status === "completed"
        ) {
          return (
            RemoveTime(sanitizedTimeTaken, step?.time_unit) +
            " / " +
            step?.count2 +
            " " +
            t(`time_unit.${step?.time_unit}`)
          );
        }else if(step?.step_status === "to_finish"){
          return (
              formatPauseTime(
                                                              step?.work_time,t
                                                            )
          ) + '/' +  step?.count2 +
            " " +
            t(`time_unit.${step?.time_unit}`)
        } else {
          return step?.count2 + " " + t(`time_unit.${step?.time_unit}`);
        }
      },
    },
    colors: colors,
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    toggle(true);
  };

  const [visoModal, setVisioModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const handleConfirm = () => {
    setVisioModal(false);
    if (selectedItem) {
      setTimeout(() => {
        const newTab = window.open(
          selectedItem?.meet_link,
          "_blank",
          "noopener,noreferrer"
        );

        if (!newTab) {
          console.error("Popup blocked! The new tab could not be opened.");
        } else {
          newTab.focus(); // Bring the new tab to the front after 5 seconds
        }
      }, 5000); // 5-second delay
    }
    continueChangeStatusAndPlay(selectedItem);
  };

  const handleClose = () => {
    setVisioModal(false);
    setSelectedItem(null);
    continueChangeStatusAndPlay(selectedItem);
  };
  const changeStatusAndPlay = async (item) => {
    const loggedInUserId = sessionStorage.getItem("user_id"); // Get the logged-in user's ID from session storage

    // Check if the item type is "Newsletter"
    if (item.type !== "Newsletter") {
      // Check if the logged-in user is in the guides array
      const isGuide =
        item?.steps?.some(
          (guide) => guide?.userPID === parseInt(loggedInUserId)
        ) ||
        // Check if all participants have user_id equal to meeting.user.id
        item?.user?.id === parseInt(loggedInUserId);

      if (!isGuide) {
        // console.log("User is not a guide. Cannot play the meeting.");
        toast.error(
          t("meeting.formState.you are not allowed to play the meeting")
        );
        return;
      }
    }

    // Check if recording should be started
    if (item?.prise_de_notes === "Automatic") {
      const hasPermission = await startRecording();
      if (!hasPermission) {
        return; // Stop if recording didn't start
      }
    }

    // Check if meeting has a Google Meet link
    if (item?.meet_link && item?.location === "Google Meet") {
      setSelectedItem(item);
      setVisioModal(true);
      return; // Wait for user confirmation before proceeding
    }

    continueChangeStatusAndPlay(item);
  };
  const continueChangeStatusAndPlay = async (item) => {
    let current_time;
    let current_date;
    let end_date;

    // Find the step with step_status "in_progress"
    const inProgressStep = item?.steps?.find(
      (step) => step?.step_status === "in_progress"
    );
    // Find the step with step_status "in_progress"
    for (const step of item?.steps || []) {
      if (step?.step_status === "in_progress" && step?.step_time) {
        current_date = step.current_date || step?.start_date;
        current_time = step.step_time;
        end_date = step?.end_date;
        break;
      }
    }

    if (!current_time || !current_date) {
      console.log("No in-progress step with current_time found.");
      return;
    }

    // Parse time with AM/PM
    const [time, meridiem] = current_time.split(" ");
    let [currentHours, currentMinutes, currentSeconds] = time
      .split(":")
      .map(Number);
    if (meridiem.toLowerCase() === "pm" && currentHours < 12) {
      currentHours += 12;
    } else if (meridiem.toLowerCase() === "am" && currentHours === 12) {
      currentHours = 0;
    }
    // Split the date string and create a new Date object
    const [day, month, year] = current_date?.split("-").map(Number);
    const myDate = `${day}/${month}/${year}`;
    const currentDateTime = new Date(myDate);

    // Update the Date object with the extracted hours, minutes, and seconds
    currentDateTime.setHours(currentHours, currentMinutes, currentSeconds);

    const realCurrentTime = new Date();

    const count2InSeconds = convertCount2ToSeconds(
      inProgressStep?.count2,
      inProgressStep?.time_unit
    );

    const differenceInMilliseconds = realCurrentTime - currentDateTime;
    const differenceInSeconds = Math.floor(differenceInMilliseconds / 1000);

    // Subtract count2InSeconds from differenceInSeconds
    const adjustedDifferenceInSeconds = differenceInSeconds - count2InSeconds;
    if (isNaN(differenceInSeconds)) {
      return;
    }

    const convertSecondsToDDHHMMSS = (seconds) => {
      if (isNaN(seconds)) {
        console.error("seconds is NaN");
        return "NaN";
      }

      const days = Math.floor(seconds / (24 * 3600));
      seconds %= 24 * 3600;
      const hours = Math.floor(seconds / 3600);
      seconds %= 3600;
      const minutes = Math.floor(seconds / 60);
      seconds %= 60;
      return `${String(days).padStart(2, "0")}d:${String(hours).padStart(
        2,
        "0"
      )}h:${String(minutes).padStart(2, "0")}m:${String(seconds).padStart(
        2,
        "0"
      )}s`;
    };

    const delay = convertSecondsToDDHHMMSS(adjustedDifferenceInSeconds);

    const updatedSteps = item?.steps?.map((step) => {
      if (step.step_status === "in_progress") {
        let savedTime = Number(step.savedTime) || 0;

        let actualStepTime = 0;
        if (step.time_unit === "days") {
          actualStepTime = Number(step.count2 * 86400);
        } else if (step.time_unit === "hours") {
          actualStepTime = Number(step.count2 * 3600);
        } else if (step.time_unit === "minutes") {
          actualStepTime = Number(step.count2 * 60);
        } else {
          actualStepTime = Number(step.count2);
        }
        const negativeTime = Number(step.negative_time) || 0;

        let newSavedTime = savedTime - differenceInSeconds;
        let newNegativeTime = negativeTime;

        let newTime = actualStepTime - differenceInSeconds;
        localStorage.setItem("newTime", newTime);
        // Adjust savedTime
        if (newTime >= 0) {
          savedTime = newTime;
          if (newTime < 0) savedTime = 0;
        }
        if (differenceInSeconds <= actualStepTime) {
          step.delay = null;
          step.savedTime = savedTime;
          step.negative_time = newNegativeTime;
        } else {
          step.delay = delay;
          step.savedTime = 0;
          step.negative_time = "99";
        }

        return {
          ...step,
          delay: step.delay,
          savedTime: step.savedTime,
          negative_time: step.negative_time,
        };
      } else {
        return {
          ...step,
        };
      }
    });

    const payload = {
      ...item,
      _method: "put",
      end_time: item.end_time,
      delay: delay,
      steps: updatedSteps,
      moment_privacy_teams:
        item?.moment_privacy === "team" &&
        item?.moment_privacy_teams?.length &&
        typeof item?.moment_privacy_teams[0] === "object"
          ? item?.moment_privacy_teams.map((team) => team.id)
          : item?.moment_privacy_teams || [], // Send as-is if IDs are already present
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/meetings/${item.id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (response.status) {
        navigate(`/play/${item.id}`);
      }
    } catch (error) {
      console.log("error while updating meeting status", error);
    }
  };

  return (
    <>
      <div id="chart-container" className="chart-content ">
        <ReactApexChart
          options={options}
          key={steps && JSON.stringify(steps)}
          series={[{ data: chartData }]}
          type="rangeBar"
          height={500}
        />
      </div>

      <div
        id="chart-containe"
        className="chart-content"
        // style={{ width: "auto", height: "auto", overflow: "hidden" }}
      >
        {isModalOpen && selectedBar !== null && (
          <div className="new-meeting-modal">
            <StepChart
              meetingId={meeting?.id}
              id={stepId}
              show={isModalOpen}
              meeting={meeting}
              setId={setStepId}
              closeModal={handleCloseModal}
              key={`step-chart-${stepId}`}
              isDrop={isDrop}
              stepIndex={selectedIndex}
              refreshMeeting={refreshMeeting}
            />
          </div>
        )}
      </div>

      {visoModal && (
        <ConfirmationModal
          message={t("Do you want to open the visioconference in a new tab?")}
          onCancel={handleClose}
          onConfirm={handleConfirm}
        />
      )}
    </>
  );
};

export default InviteStepChart;
